import { Link } from 'react-router-dom';
import { usePlatformsHeroContent } from '../../../../hooks/usePlatformsHeroContent';
import heroImage from '../../../../assets/images/platforms/hero/hero.jpg';
import './Hero.css';

const Hero = () => {
  const { content, isLoading } = usePlatformsHeroContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, text, cta, image } = content;

  return (
    <section className="platforms-hero">
      <div className="platforms-hero__inner">
        <div className="platforms-hero__copy">
          {eyebrow ? <p className="platforms-hero__eyebrow">{eyebrow}</p> : null}
          <h1 className="platforms-hero__title">{title}</h1>
          {text ? <p className="platforms-hero__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="platforms-hero__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </div>
      </div>

      <div className="platforms-hero__media">
        <img
          className="platforms-hero__image"
          src={image || heroImage}
          alt=""
          aria-hidden="true"
        />
      </div>
    </section>
  );
};

export default Hero;
